import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ActivitiesPage from "@/pages/activities/page";
import TrainingDetailPage from "@/pages/activities/detail/page";
import MasterCoursesPage from "@/pages/courses/master/page";
import HospitalCoursesPage from "@/pages/courses/hospital/page";
import CourseDetailPage from "@/pages/courses/detail/page";
import HospitalsPage from "@/pages/hospitals/page";
import HospitalDetailPage from "@/pages/hospitals/detail/page";
import DiseasesPage from "@/pages/diseases/page";
import DiseaseDetailPage from "@/pages/diseases/detail/page";
import AchievementsPage from "@/pages/achievements/page";
import AchievementDetailPage from "@/pages/achievements/detail/page";
import VideosPage from "@/pages/videos/page";
import VideoDetailPage from "@/pages/videos/detail/page";
import DoctorsPage from "@/pages/doctors/page";
import DoctorDetailPage from "@/pages/doctors/detail/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/courses",
    element: <Navigate to="/courses/master" replace />,
  },
  {
    path: "/courses/master",
    element: <MasterCoursesPage />,
  },
  {
    path: "/courses/hospital",
    element: <HospitalCoursesPage />,
  },
  {
    path: "/courses/:id",
    element: <CourseDetailPage />,
  },
  {
    path: "/activities",
    element: <ActivitiesPage />,
  },
  {
    path: "/activities/:id",
    element: <TrainingDetailPage />,
  },
  {
    path: "/hospitals",
    element: <HospitalsPage />,
  },
  {
    path: "/hospitals/:id",
    element: <HospitalDetailPage />,
  },
  {
    path: "/diseases",
    element: <DiseasesPage />,
  },
  {
    path: "/diseases/:id",
    element: <DiseaseDetailPage />,
  },
  {
    path: "/achievements",
    element: <AchievementsPage />,
  },
  {
    path: "/achievements/:id",
    element: <AchievementDetailPage />,
  },
  {
    path: "/videos",
    element: <VideosPage />,
  },
  {
    path: "/videos/:id",
    element: <VideoDetailPage />,
  },
  {
    path: "/doctors",
    element: <DoctorsPage />,
  },
  {
    path: "/doctors/:id",
    element: <DoctorDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;